import { Component, OnInit } from "@angular/core";
import { SessionStateService } from "../../../core/services/session-state.service";
import { HousesService } from "../../../entities/houses/houses.service";
import { House } from "../../../entities/houses/houses.model";
import { GeneralService } from "../../../shared/services/general.service";
import { DevicesService } from "../../../entities/devices/devices.service";
import {
  Router,
  ActivatedRoute,
  RoutesRecognized,
  Params,
} from "@angular/router";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/concatMap";
import { MatSnackBar, MatDialog, MatDialogRef } from "@angular/material";
import { SnackBarComponent } from "./snack-bar/snack-bar.component";
import { IotService } from "../../../core/services/iot.service";
import { LoginService } from "../../../shared/components/login/login.service";
import { AuthenticationService } from "../../../core/services/authentication.service";
import { AlertService } from "../../../shared/components/alert/alert.service";
import { Subscription } from "rxjs/Subscription";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-sidebar-layout",
  templateUrl: "./sidebar-layout.component.html",
  styleUrls: ["./sidebar-layout.component.scss"],
})
export class SidebarLayoutComponent implements OnInit {
  barActive = false;
  houseName: String;
  clientAddress: String;
  clientHouses: Array<House> = [];
  selectedHouseIndex: number;
  noHouse = false;
  isMobile;
  isWindowsPhone = false;
  constructor(
    private dialog: MatDialog,
    private sessionStateService: SessionStateService,
    private generalService: GeneralService,
    private housesService: HousesService,
    private devicesService: DevicesService,
    private iotService: IotService,
    private router: Router,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    private loginService: LoginService,
    private authenticationService: AuthenticationService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.isMobile = this.generalService.isMobile();
    this.isWindowsPhone = this.generalService.isWindowsPhone();
    const house = this.sessionStateService.getHouse();
    if (house) {
      this.houseName = house.name;
      this.clientAddress = house.address;
    } else {
      this.houseName = "My House";
      this.clientAddress = "EDP";
    }
    this.getHouses().subscribe(() => {
      this.getQueryParams();
    });
  }

  getQueryParams() {
    this.route.queryParams.subscribe((params: Params) => {
      const houseId = params["houseId"];
      if (houseId !== undefined) {
        const houseIndex = this.clientHouses.findIndex(
          (house) => house.houseId === houseId
        );
        if (houseIndex === -1) {
          this.router.navigateByUrl("/");
        } else {
          this.selectHouse(houseIndex);
        }
      }
    });
  }

  getServiceProvider() {
    return this.sessionStateService.getHouse().serviceProvider;
  }

  getHouseName() {
    return this.sessionStateService.getHouse().name;
  }

  islargeDesktop(): boolean {
    return window.innerWidth > 1366;
  }

  isClientNameLarge(): boolean {
    return this.clientAddress && this.clientAddress.length > 24;
  }

  onDismiss() {
    this.barActive = !this.barActive;
  }

  getClientAddress() {
    return this.sessionStateService.getHouse().address;
  }

  getHouses() {
    return (
      this.housesService
        .getHouses()
        .map((res) => {
          this.clientHouses = res;
          this.noHouse = false;
          if (!this.sessionStateService.getHouse()) {
            this.selectedHouseIndex = 0;
            this.sessionStateService.setHouse(
              this.clientHouses[this.selectedHouseIndex]
            );
            //return this.selectSmartDeviceId();
          } else {
            this.clientHouses.forEach((house) => {
              if (
                house.houseId === this.sessionStateService.getHouse().houseId
              ) {
                this.selectedHouseIndex = this.clientHouses.indexOf(house);
                this.sessionStateService.setHouse(
                  this.clientHouses[this.selectedHouseIndex]
                );
              }
            });
          }
        })
        .catch((err) => {
          this.noHouse = true;
          return Observable.empty();
        })
        // .concatMap(() => this.selectSmartDeviceId())
        .concatMap(() => this.selectHouseTariff())
    );
  }

  selectHouse(i: number) {
    if (this.selectedHouseIndex !== i) {
      this.selectedHouseIndex = i;
      // console.log('TCL: SidebarLayoutComponent -> selectHouse -> this.clientHouses', this.clientHouses);
      // console.log('TCL: SidebarLayoutComponent -> selectHouse -> this.clientHouses[this.selectedHouseIndex]',
      // this.clientHouses[this.selectedHouseIndex]);
      this.sessionStateService.setHouse(
        this.clientHouses[this.selectedHouseIndex]
      );
      this.iotService.disconnect();
      this.sessionStateService.setSmartDevices(null);

      return (
        this.selectSmartDeviceId()
          .concatMap(() => this.selectHouseTariff())
          //return this.selectHouseTariff()
          .subscribe(
            () => {
              const currentRoute = this.router.url;
              this.router
                .navigateByUrl(`/page-not-found`, { skipLocationChange: true })
                .then(() => {
                  // Navigates to reports page, based on URL
                  if (currentRoute.includes("energyType=REPORTS")) {
                    this.router.navigateByUrl(`${currentRoute}`);
                  }
                  // For all other scenarios, navigate directly to home, to guarantee that everything is
                  // correctly loaded to cache / cookies
                  else {
                    this.router.navigateByUrl("/home");
                  }
                  this.alertService.info(
                    "The location has been switched to " +
                      this.clientHouses[this.selectedHouseIndex].name +
                      ".",
                    false
                  );
                });
            },
            (err) => {
              const currentRoute = this.router.url;
              this.router
                .navigateByUrl(`/page-not-found`, { skipLocationChange: true })
                .then(() => {
                  this.router.navigateByUrl(`${currentRoute}`);
                });
            }
          )
      );
    }

    if (this.router.url === "/energy/no-smart-meter") {
      this.router.navigateByUrl(`/`);
    }
  }

  validateName(username: string) {
    if (username && username.length > 15) {
      return username.substring(0, 15) + " ...";
    } else {
      return username;
    }
  }

  selectSmartDeviceId(): Observable<any> {
    return this.devicesService
      .getHouseDevice(this.sessionStateService.getHouse().houseId)
      .map((response) => {
        response.forEach((smartDevice) => {
          const smartDevicesItems = [{ type: "redybox" }, { type: "wifi" }];
          const smartDevicesToSet = [];

          for (const item of smartDevicesItems) {
            if (item.type === smartDevice.type) {
              smartDevicesToSet.push(smartDevice);
            }
          }

          this.sessionStateService.setSmartDevices(smartDevicesToSet);
        });
      })
      .catch((err) => {
        this.sessionStateService.setSmartDevices(null);
        return of(empty);
      });
  }

  selectHouseTariff(): Observable<any> {
    return this.housesService
      .getHouseTariff(this.sessionStateService.getHouse().houseId)
      .map((response) => {
        if (response.electricity) {
          this.sessionStateService.setHouseTariff({
            tariff: response.electricity.hourOption,
            cycle: response.electricity.cycle,
          });
        }
        if (response.gas) {
          this.sessionStateService.setHouseTariff({
            tariff: response.gas.hourOption,
            cycle: response.gas.cycle,
            geography: response.gas.geography,
            costRate: response.gas.costRate,
          });
        }
      });
  }

  openSnackBar() {
    setTimeout(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        duration: 3000,
        verticalPosition: "bottom",
        panelClass: "snackbar-panel",
      });
      setTimeout(() => {
        this.snackBar.dismiss();
      }, 3500);
    }, 500);
  }

  userHasNoHouse() {
    const house = this.sessionStateService.getHouse();
    if (house) {
      this.noHouse = false;
    }
    return this.noHouse;
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/gui-layout/sidebar-layout/sidebar-layout.component.ts